// src/components/Education.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Education = ({ language }) => {
  const [programs, setPrograms] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_BASE_URL +
          "continues-training/get-allcontinues-trainings"
      )
      .then((res) => setPrograms(res.data.data));
  }, []);

  const displayedPrograms = programs.slice(0, 4);

  const handleShowMore = () => {
    navigate("/education");
  };

  return (
    <section id="education" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4">
            {language === "ar" ? "التدريب المستمر" : "Continues Training"}
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            {language === "ar"
              ? "برامجنا مصممة لتلبية الاحتياجات التدريبية لجميع العاملين في المستويات المختلفة بهدف رفع مستوي السلوكيات - المعرفة - المهارات . وتبادل الخبرة ونقل المعرفة فيما بين الادارات والعاملين"
              : "Our programs are designed to meet the training needs of all employees at different levels, aiming to enhance behaviors, knowledge, and skills, and to facilitate the exchange of expertise and knowledge transfer between departments and employees."}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {displayedPrograms.map((program, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-green-700 to-green-800 text-white rounded-xl p-6 shadow-lg transform hover:-translate-y-2 transition-all duration-300"
            >
              <h3 className="font-bold text-lg mb-4">
                {language === "ar" ? program.title_ar : program.title}
              </h3>

              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span>
                    {language === "ar" ? "عدد المجموعات:" : "Number of Groups:"}
                  </span>
                  <span className="font-bold text-green-200">
                    {program.groups}
                  </span>
                </div>

                <div className="flex justify-between items-center">
                  <span>
                    {language === "ar"
                      ? "عدد المدربين:"
                      : "Number of Trainers:"}
                  </span>
                  <span className="font-bold text-green-200">
                    {program.trainers}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Show More Button */}
        {programs.length > 4 && (
          <div className="text-center mt-8">
            <button
              onClick={handleShowMore}
              className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              {language === "ar" ? "عرض المزيد" : "Show More"}
            </button>
          </div>
        )}

        {/* Statistics Section */}
        <div className="mt-16 bg-green-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-green-900 text-center mb-8">
            {language === "ar"
              ? "إحصائيات التدريب المستمر"
              : "Continuing Training Statistics"}
          </h3>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              {
                number: "3,300+",
                label: { en: "Trained Employees", ar: "موظف مدرب" },
              },
              {
                number: "20+",
                label: { en: "Training Programs", ar: "برنامج تدريبي" },
              },
              {
                number: "95%",
                label: { en: "Satisfaction Rate", ar: "معدل الرضا" },
              },
              {
                number: "10+",
                label: { en: "Training Partners", ar: "شركاء التدريب" },
              },
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl font-bold text-green-800 mb-2">
                  {stat.number}
                </div>
                <div className="text-green-700">
                  {language === "ar" ? stat.label.ar : stat.label.en}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
